<div
  class="question-mark"
  rkTooltip
  [tooltipDescription]="description"
  [tooltipPosition]="tooltipPosition"
  [arrowPosition]="arrowPosition"
>
  <mat-icon fontSet="fa" fontIcon="fa-question"></mat-icon>
</div>
